import { render, staticRenderFns } from "./es_p295.vue?vue&type=template&id=b0857638"
import script from "./es_p295.vue?vue&type=script&lang=js"
export * from "./es_p295.vue?vue&type=script&lang=js"
import style0 from "./es_p295.vue?vue&type=style&index=0&id=b0857638&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {P295SmartBuyCard: require('/root/containers/hermes_eshop/components/hyper/p295/p295_smart_buy_card.vue').default,ElementsCoreRow: require('/root/containers/hermes_eshop/components/core/elements/coreRow.vue').default,ElementBuilder: require('/root/containers/hermes_eshop/components/core/elementBuilder.vue').default,P295Filters: require('/root/containers/hermes_eshop/components/hyper/p295/p295_filters.vue').default,P295EsHeader: require('/root/containers/hermes_eshop/components/hyper/p295/p295_es_header.vue').default,Product: require('/root/containers/hermes_eshop/components/core/product.vue').default,ElasticPagination: require('/root/containers/hermes_eshop/components/core/elasticPagination.vue').default})
